import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useAuthStore } from '@/features/auth/model/auth-store';

/**
 * Обратный гард для экрана входа.
 *
 * Закрывает два случая, в которых пользователь застревал на форме:
 *
 *  1. **Сразу после успешного входа.** Форма меняла состояние сессии, но никто
 *     не уводил с `/auth`, и человек продолжал видеть тот же экран — со
 *     стороны это выглядело как «кнопка не сработала».
 *  2. **При возврате в приложение.** Открытый по закладке `/auth` показывал
 *     форму даже при живой сессии.
 *
 * Редирект сделан реактивным, а не вызовом `navigate()` после входа: статус
 * меняется и через восстановление сессии при запуске, и через демо-вход, —
 * одно правило в маршруте покрывает все пути сразу.
 */
export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);

  if (status === 'authenticated') {
    return <Navigate to="/calendar" replace />;
  }

  return <>{children}</>;
}
